// extracted by mini-css-extract-plugin
export default {"TransactionsHistory__title":"TransactionsHistorySuccess_TransactionsHistory__title__yX4Ml"};